import axios from '../../helpers/axios-setup';

export const getOwningCompaniesInAllLabRequests = () => {
  return axios.get(`/companies/owning-companies-of-lab-request-for-lab`);
};
